import { render } from "./TeamInviteModal.vue?vue&type=template&id=fe924dde"
import script from "./TeamInviteModal.vue?vue&type=script&lang=js"
export * from "./TeamInviteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/TeamInviteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe924dde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe924dde', __exports__)) {
    api.reload('fe924dde', __exports__)
  }
  
  module.hot.accept("./TeamInviteModal.vue?vue&type=template&id=fe924dde", () => {
    api.rerender('fe924dde', render)
  })

}


export default __exports__